import axios from 'axios';

module.exports = {
  methods: {
    getPickupDates (gaEvent, gaSubType) {    
      this.status = 'LOADING'

      if (gaEvent) {
        dataLayer.push({ 
          'event': gaEvent,
          'subType': gaSubType
        })
      }
      
      axios.get(`/api/pickupapi/pickupdates?address=${encodeURIComponent(this.address)}`)
      .then((res) => {
        this.dates = res.data.result;

        // Change the status on a timeout to prevent a flicker if loaded fast
        setTimeout(() => {
          this.status = res.data.status;
        }, 500);

        // Pass errors to Google Analytics
        if (res.data.status == 'NOT_ASSIGNED' || 
            res.data.status == 'NO_SERVICE') {
          dataLayer.push({
            'event': 'nopickupfound', 
            'reason' : res.data.status,  
            'address' : this.address
          });
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
          window.location.href = '/error?statusCode=500';
        } else {
          this.status = 'ERR';
        }
      });
    }
  }
}


// WEBPACK FOOTER //
// ./src/js/pickup/mixins/method-getPickupDates.js